import request from '@/core/http/request'

//字典
export function listAll(data) {
    return request({
        url: '/admin/upms/globalDict/listAll',
        method: 'get',
        params: data
    })
}

//获取当前登录者公司名称
export function getSysTenantByTenantCode(data) {
    return request({
        url: '/admin/upms/sysTenantAdmin/getSysTenantByTenantCode',
        method: 'get',
        params: data
    })
}

// 
export function getLoginInfo() {
    return request({
        url: '/admin/upms/login/getLoginInfo',
        method: 'get'
    })
}
